// extracted by mini-css-extract-plugin
export default {"container":"QueryResponse_container__UoLA4","input":"QueryResponse_input__20clt","textarea":"QueryResponse_textarea__3t97V","handle":"QueryResponse_handle__-Nzcj"};